import { Controller } from "stimulus"

const COOKIE_NAME = 'chatMessageCount'
const SURVEY_THRESHOLD = 3
const EXPIRATION_MONTHS = 6

export default class extends Controller {

  connect() {
    this.counter = this.getMessageCounter()
    this.hideSurvey()
  }

  addCounter() {
    this.counter++
    this.updateMessageCounter()

    if (this.shouldShowSurvey()) this.showSurvey()
  }

  shouldShowSurvey() {
    return (this.counter === SURVEY_THRESHOLD || this.counter % 6 === 0)
  }

  getMessageCounter() {
    const cookieValue = document.cookie
      .split('; ')
      .find(cookie => cookie.startsWith(`${COOKIE_NAME}=`))
      ?.split('=')[1]

    const parsed = parseInt(cookieValue, 10)
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0
  }

  updateMessageCounter() {
    const expiryDate = new Date()
    expiryDate.setMonth(expiryDate.getMonth() + EXPIRATION_MONTHS)

    const cookieString = [
      `${COOKIE_NAME}=${this.counter}`,
      `expires=${expiryDate.toUTCString()}`,
      'path=/',
      'SameSite=Strict'
    ].join('; ')

    document.cookie = cookieString
  }

  showSurvey() {
    const surveySelector = '[class^="PostHogSurvey"]';
    const surveyElement = document.querySelector(surveySelector);

    if (!surveyElement) {
      return;
    }

    const shadowRoot = surveyElement.shadowRoot;
    const style = document.createElement('style');

    if (!shadowRoot) {
      return;
    }

    surveyElement.style.display = 'block';
    const surveyForm = shadowRoot.querySelector('.survey-form');
    if (surveyForm && surveyForm.parentElement) {
      surveyForm.parentElement.classList.add('survey-form-container');
    }

    style.textContent = `
      .survey-form-container {
        bottom: 50px;
        border-bottom: 1.5px solid #c01489;
        border-radius: 10px;
      }

      .survey-form {
        border-radius: 10px;
      }

      @media (max-width: 767px) {
        .survey-form-container {
          right: unset !important;
          left: 50%;
          transform: translateX(-50%) !important;
          bottom: unset;
          top: 110px;
        }
      }
    `;

    shadowRoot.appendChild(style);
  }

  hideSurvey() {
    const style = document.createElement('style');
    style.textContent = `
      [class^="PostHogSurvey"] {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }
}